import * as React from "react";
import { dispatch } from "@rematch/core";
import Country from "./country";
import City from "./city";
import Area from "./area";
import FormModel from "../../viewModel/formModel";
import CountryCity from "./countryCity";

const onSelectChange = (e, field, modelName) => {
  let data = {};
  data[field] = e;

  dispatch["antDemo"].setValue({
    formInfo: data,
    model: modelName,
    field,
    value: e
  });
};

export const getCountry = (formModel: FormModel) => {
  const onChange = (e, field) => {
    onSelectChange(e, field, formModel.modelName);
  };
  return (
    <Country
      width={formModel.width}
      value={formModel.value}
      onChange={formModel.onChange || onChange}
      modelName={formModel.modelName}
      //这里的对应redux中的属性(字段)
      data-field={formModel.field}
      // 这里对应城市字段
      city-field={formModel.extField1}
      // 这里对应区域字段
      area-field={formModel.extField2}
      isLoadCity={formModel.extFieldValue4}
    />
  );
};

export const getCity = (formModel: FormModel) => {
  const onChange = (e, field) => {
    onSelectChange(e, field, formModel.modelName);
  };
  return (
    <City
      width={formModel.width}
      value={formModel.value}
      onChange={formModel.onChange || onChange}
      modelName={formModel.modelName}
      //这里的对应redux中的属性(字段)
      data-field={formModel.field}
      // 这里对应区域字段
      area-field={formModel.extField1}
      isLoadArea={formModel.extFieldValue4}
    />
  );
};

export const getArea = (formModel: FormModel) => {
  const onChange = (e, field) => {
    onSelectChange(e, field, formModel.modelName);
  };
  return (
    <Area
      width={formModel.width}
      value={formModel.value}
      onChange={formModel.onChange || onChange}
      //这里的对应redux中的属性(字段)
      data-field={formModel.field}
    />
  );
};

export const getCountryCity = (formModel: FormModel) => {
  let countryForm = new FormModel();
  countryForm = { ...formModel };
  countryForm.width = 120;
  countryForm.field = formModel.field;
  countryForm.value = formModel.value;
  countryForm.extField1 = formModel.extField1;
  countryForm.extField2 = formModel.extField2;
  countryForm.extFieldValue1 = formModel.extFieldValue1;
  countryForm.extFieldValue2 = formModel.extFieldValue2;
  // 映射country中的isLoadCity 属性
  countryForm.extFieldValue4 = true;

  let cityForm = new FormModel();
  cityForm = { ...formModel };
  cityForm.width = 120;
  cityForm.field = formModel.extField1;
  cityForm.value = formModel.extFieldValue1;
  cityForm.extField1 = formModel.extField2;

  return <CountryCity countryFormData={countryForm} cityFormData={cityForm} />;
};
